import { Component, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Cases from "@/components/Cases";
import Valuation from "@/components/Valuation";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import LegalPage from "@/pages/LegalPage";
import FiscalCalculator from "@/pages/FiscalCalculator";
import Circulante from "@/pages/Circulante";
import Compra from "@/pages/Compra";
import TestVenta from "@/pages/TestVenta";
import Sensibilidad from "@/pages/Sensibilidad";
import AdminPage from "@/pages/AdminPage";
import { AVISO_LEGAL, COOKIES, PRIVACIDAD } from "@/lib/legalContent";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink text-white">
          Algo ha ido mal. Recarga la página.
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Home() {
  useEffect(() => {
    document.title = "Venta de Empresas y Consultoría M&A | AJG M&A Consulting";
  }, []);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <Cases />
        <Valuation />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <div className="bg-ink text-white antialiased">
          <div className="grain" aria-hidden />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/aviso-legal" element={<LegalPage data={AVISO_LEGAL} />} />
            <Route path="/privacidad" element={<LegalPage data={PRIVACIDAD} />} />
            <Route path="/cookies" element={<LegalPage data={COOKIES} />} />
            <Route path="/herramientas/calculadora-fiscal" element={<FiscalCalculator />} />
            <Route path="/herramientas/diagnostico-circulante" element={<Circulante />} />
            <Route path="/herramientas/cuanto-puedo-pagar" element={<Compra />} />
            <Route path="/herramientas/test-venta" element={<TestVenta />} />
            <Route path="/herramientas/simulador-margenes" element={<Sensibilidad />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <WhatsAppButton />
          <Toaster richColors position="bottom-left" />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
